import { Button } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import React, { useEffect } from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import MakeAsyncFunction from "react-redux-promise-listener";
import { useParams } from "react-router-dom";
import {
  EDIT_PRODUCT_OPTION_ERROR,
  EDIT_PRODUCT_OPTION_REQUEST,
  EDIT_PRODUCT_OPTION_RESPONSE,
} from "../../../../actions/productOption.actions";
import { appActions } from "../../../../actions/app.actions";
import { promiseListener } from "../../../../helpers/store";
import OptionsForm from "./OptionsForm";

export default function OptionsEdit() {
  let { optionId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(appActions.setNextPage("/thermo/options"));
  }, [dispatch]);

  let option = useSelector((state) => {
    return state.productOptions.all[optionId] || {};
  });

  return (
    <div>
      <MakeAsyncFunction
        listener={promiseListener}
        start={EDIT_PRODUCT_OPTION_REQUEST}
        resolve={EDIT_PRODUCT_OPTION_RESPONSE}
        reject={EDIT_PRODUCT_OPTION_ERROR}
      >
        {(onSubmit) => (
          <Form
            onSubmit={(form) => {
              return onSubmit(form);
            }}
            mutators={{
              setValue: ([field, value], state, { changeValue }) => {
                changeValue(state, field, () => value);
              },
            }}
            initialValues={option}
            render={({ handleSubmit, submitting, form }) => (
              <form onSubmit={handleSubmit}>
                <OptionsForm
                  setValue={form.mutators.setValue}
                />

                <Box mt={1} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={submitting}
                  >
                    Editer
                  </Button>
                </Box>
              </form>
            )}
          />
        )}
      </MakeAsyncFunction>
    </div>
  );
}
